<template>
  <v-card>
    <v-toolbar class="bg-white h-auto">
      <div class="d-flex align-items-center justify-content-between w-100">
        <div class="d-flex gap-2 align-items-center">
          <v-btn style="padding: 0px" @click="closeDocumentDetailsDialog()">
            <v-icon>
              {{
                $i18n.locale === "ar" ? "mdi-chevron-right" : "mdi-chevron-left"
              }}
            </v-icon>
          </v-btn>
          <h2 class="page-title text_align_center" style="font-size: 18px">
            {{ $t("res_Label_DocumentDetail") }}
          </h2>

          <h2 class="page-title text_align_center" style="font-size: 18px"></h2>
          <v-icon @click="refresh()">custom-icon mdi-refresh</v-icon>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex align-items-center toolbar-icons">
          <v-btn
            class="dgs-new-button-icon"
            icon
            @click="printWithAttachments(false)"
            v-tooltip="$t('res_Label_Print')"
          >
            <v-icon class="primary-hover">mdi-printer</v-icon>
          </v-btn>
          <v-btn
            class="dgs-new-button-icon"
            icon
            @click="downloadWithAttachments"
            v-tooltip="$t('res_Label_Download')"
          >
            <v-icon class="primary-hover">mdi-download</v-icon>
          </v-btn>
        </div>
        <div>
          <v-btn style="padding: 0px">
            <v-icon @click="closeDocumentDetailsDialog()"
              >custom-icon mdi-close</v-icon
            >
          </v-btn>
        </div>
      </div>
    </v-toolbar>
    <div class="dialog-body h-100" style="overflow: hidden;">
      <!-- v-if="this.document && this.document.documentId > 0" -->
      <div
        class="row m-0 h-100"
        v-if="this.documentId && this.documentDetail.documentId > 0"
        style="display: flex; flex-wrap: nowrap;"
      >
        <div class="form-section col-md-4 col-lg-4 p-0 m-0 h-100" style="overflow-y: auto; flex-shrink: 0;">
          <div class="main-bg-color">
            <div class="side-components-inner">
              <div class="inner-single-component" v-if="documentId != 0">
                <div class="d-flex align-items-start">
                  <div
                    class="ref_header_name"
                    v-if="
                      !utils.CheckIfNullOrEmpty(
                        this.documentDetail.referenceNumber
                      )
                    "
                  >
                    {{ this.documentDetail.referenceNumber }}
                  </div>
                </div>
                <!-- controls in view mode -->
                <div
                  class="form-sub-section view-details-section"
                  v-if="documentId != 0 || viewMode == 'readonly'"
                >
                  <v-divider v-if="!collapseReadOnlyDetails"></v-divider>
                  <div
                    :style="{
                      display: collapseReadOnlyDetails ? 'none' : 'block',
                    }"
                  >
                    <div class="bg-color-buble">
                      <div class="sender-receiver-box">
                        <div class="text-start">
                          <span class="action-label-new">{{
                            $t("res_Label_DueDate")
                          }}</span>
                          <p class="main-text-large m-0">
                            <label
                              v-if="documentDetail.balanceDays < 1"
                              class="text-warning mx-2"
                            >
                              <v-icon>mdi-overdue</v-icon>
                              {{ documentDetail.balanceDays }}
                            </label>
                            {{ utils.dateFormat(documentDetail.dueDate) }}
                          </p>
                        </div>
                        <div
                          class="text-end"
                          v-if="
                            !utils.CheckIfNullOrEmpty(documentDetail?.createdOn)
                          "
                        >
                          <span class="action-label-new">{{
                            $t("res_Label_DocumentDate")
                          }}</span>
                          <p class="main-text-large m-0">
                            {{ utils.dateFormat(documentDetail.createdOn) }}
                          </p>
                        </div>
                      </div>
                      <div class="sender-receiver-box">
                        <div>
                          <span class="action-label-new">{{
                            $t("res_Label_Priority")
                          }}</span>
                          <p
                            class="main-text-large m-0"
                            :class="
                              utils.getPriorityClassColor(
                                this.documentDetail.priorityId
                              )
                            "
                            v-if="
                              utils.getPriorityName(
                                this.documentDetail.priorityId
                              )
                            "
                          >
                            {{
                              $t(
                                "priority_" +
                                  utils
                                    .getPriorityName(
                                      this.documentDetail.priorityId
                                    )
                                    .toLowerCase()
                              )
                            }}
                          </p>
                        </div>
                        <div class="text-end">
                          <span class="action-label-new">{{
                            $t("Status")
                          }}</span>
                          <div>
                            <v-chip
                              dark
                              :style="{
                                backgroundColor: constants.statusesEnum
                                  .getById(this.documentDetail.statusId)
                                  .data().classColor,
                                color: textColor(
                                  constants.statusesEnum
                                    .getById(this.documentDetail.statusId)
                                    .data().classColor
                                ),
                              }"
                              v-bind:class="
                                utils.getStatusClass(
                                  this.documentDetail.statusId
                                )
                              "
                            >
                              {{
                                $t(
                                  "status_" +
                                    utils.getStatus(
                                      this.documentDetail.statusId
                                    )
                                )
                              }}</v-chip
                            >
                          </div>
                        </div>
                      </div>
                      <div class="sender-receiver-box">
                        <div v-if="this.documentDetail.subject.length > 30">
                          <span class="action-label-new">{{
                            $t("res_Label_Subject")
                          }}</span>
                          <p
                            v-tooltip="this.documentDetail.subject"
                            class="main-text-large m-0"
                          >
                            {{
                              this.documentDetail.subject.slice(0, 30) + "..."
                            }}
                          </p>
                        </div>
                        <div v-else>
                          <span class="action-label-new">{{
                            $t("res_Label_Subject")
                          }}</span>
                          <p
                            v-tooltip="this.documentDetail.subject"
                            class="main-text-large m-0"
                          >
                            {{ this.documentDetail.subject }}
                          </p>
                        </div>
                        <div class="text-end">
                        <span class="action-label-new">{{
                            $t("res_Label_Sender")
                          }}</span>
                          <p
                            v-tooltip="this.documentDetail.senderName"
                            class="main-text-large m-0"
                          >
                            {{
                              this.documentDetail.senderName
                            }}
                          </p>
                      </div>
                      </div>
                    <div class="sender-receiver-box">
                        <div>
                            <span class="action-label-new">{{
                            $t("res_Label_Privacy")
                          }}</span>
                          <p
                            v-tooltip="this.documentDetail.privacy"
                            class="main-text-large m-0"
                          >
                            {{ this.documentDetail.privacy }}
                          </p>
                        </div>
                          
                        <div class="text-end">
                        <span class="action-label-new">{{
                            $t("res_Label_Importance")
                          }}</span>
                          <p
                            v-tooltip="this.documentDetail.importance"
                            class="main-text-large m-0"
                          >
                            {{
                              this.documentDetail.importance
                            }}
                          </p>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <!-- attachments -->
            <div class="inner-single-component">
              <Attachments
                ref="attachmentCtrl"
                :documentId="documentId"
                :viewMode="canAddEditAttachments() ? 'edit' : 'readonly'"
                @setViewerUrl="setViewerUrl"
                :disabledUpload="
                  utils.CheckIfNullOrEmpty(documentDetail.referenceNumber)
                "
                :canAddAttachments="canEditAttachments()"
                :canEditAttachments="canEditAttachments()"
                :delegationId="delegationId"
                :isSentTab="isSentTab"
              >
              </Attachments>
            </div>
            <!-- duplicate attachments section for sent tab -->
            <div class="inner-single-component" v-if="isSentTab">
              <Attachments
                ref="attachmentCtrl2"
                :documentId="documentId"
                :viewMode="'readonly'"
                @setViewerUrl="setViewerUrl"
                :disabledUpload="true"
                :canAddAttachments="false"
                :canEditAttachments="false"
                :delegationId="delegationId"
                :isSentTab="isSentTab"
                :replyAttachments="true"
              >
              </Attachments>
            </div>
            <br />
            <br />
            <!-- notes -->
            <div class="inner-single-component hide"></div>

            <br />
          </div>
        </div>

        <div class="viewer-wrapper col-md-8 col-lg-8 h-100 p-0 m-0" style="overflow: hidden; flex-shrink: 0;">
          <!--viewer section-->
          <div class="d-flex flex-column h-100">
            <div class="p-0 scrollable-container flex-1 overflow-hidden">
              <div v-if="empty_viewer" class="empty-viewer">
                <img src="/assets/images/icons/no_preview.svg" />
                <p class="mt-4 weight-400">
                  {{ $t("res_Msgs_NoPreviewAvailable") }}
                </p>
              </div>
              <div v-if="!empty_viewer" id="viewer_template" class="h-100">
                <iframe
                  id="viewerFrame"
                  :src="viewerFrameSrc"
                  class="h-100 w-100"
                ></iframe>
              </div>
            </div>

            <!--Actions buttons-->

            <div
              class="dialog-footer sticky-footer top-shadow py-2 px-3 d-flex align-items-center justify-content-between position-relative"
              v-if="!isSentTab"
            >
              <div class="d-flex align-items-center justify-content-start">
                <div
                  style="padding-left: 5px; padding-right: 5px"
                  class="d-flex gap-2 ml-auto"
                >
                  <v-btn
                    class="light-success"
                    @click="signDocument"
                    v-if="
                      !documentDetail.isSingedByUser &&
                      !documentDetail.isReviewer
                    "
                    v-tooltip="$t('res_ButtonText_Sign')"
                  >
                    <v-icon style="color: #009639"
                      >mdi-account-edit-outline</v-icon
                    >&nbsp;{{ $t("res_Label_Reply") }}
                  </v-btn>

                  <v-btn
                    class="light-success"
                    @click="reviewDocument"
                    v-if="
                      !documentDetail.isSingedByUser &&
                      documentDetail.isReviewer
                    "
                    v-tooltip="$t('res_ButtonText_Sign')"
                  >
                    <v-icon style="color: #009639"
                      >mdi-checkbox-marked-circle-outline</v-icon
                    >&nbsp;{{ $t("res_ButtonText_Reviewed") }}
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-overlay :value="dispatchFormDialog">
      <v-dialog
        v-model="dispatchFormDialog"
        content-class="dialog with-fixed-actions bg-white w-40 right"
        fullscreen
        width="70%"
        scrollable
      >
        <v-card>
          <v-toolbar class="bg-white">
            <v-card-title class="p-0">
              {{ $t("res_DialogHeaders_DispatchLetter") }}
            </v-card-title>
            <v-spacer></v-spacer>
            <v-btn
              class="close-btn light-btn"
              icon
              dark
              @click="dispatchFormDialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <DispatchLetter
            :documentId="documentId"
            :senderName="documentDetail.senderName"
            :referenceNumber="documentDetail.referenceNumber"
            @closeDialog="handleCloseDispatchDialog"
          ></DispatchLetter>
        </v-card>
      </v-dialog>
    </v-overlay>
  </v-card>
</template>
<script>
import * as utils from "@/assets/js/common.js";
import axios from "axios";
import constants from "@/assets/js/constants";
import { createVuetify } from "vuetify";
import $ from "jquery";
import Attachments from "@/components/Attachments.vue";
import SignSelectSignMethod from "@/components/SelectSignMethod.vue";
import DispatchLetter from "@/components/DispatchLetter.vue";
export default {
  name: "DocumentDetailView",
  components: {
    createVuetify,
    utils,
    constants,
    Attachments,
    SignSelectSignMethod,
    DispatchLetter,
  },
  props: {
    documentId: { type: Number, default: 0 },
    viewMode: { type: String, default: "readonly" },
    isSentTab: { type: Boolean, default: false },
  },
  data() {
    return {
      utils: utils,
      constants: constants,
      documentDetail: {
        documentId: null,
        status: null,
        statusId: null,
        isLocked: true,
        referenceNumber: "",
        subject: "",
        createdOn: "",
        dueDate: "",
        balanceDays: "",
        createdBy: "",
        priority: "",
        priorityId: "",
        senderName: "",
      },
      PrintOptions: false,
      collapseLetterDetails: true,
      collapseReadOnlyDetails: true,
      collapseLinkedDocuments: true,
      collapseAttachments: true,
      collapseDeliveryNotes: true,
      collapseSigners: true,
      empty_viewer: true,
      viewerFrameSrc: "",
      attachmentId: 0,
      delegationId: 0,
      selectSignMethodFormDialog: false,
      propertyBag: {},
      signFormDialog: false,
      dispatchFormDialog: false,
    };
  },
  watch: {
    documentId: function () {
      this.viewerFrameSrc = "";
      if (this.documentId > 0) {
        this.getDocumentDetails();
      } else {
        this.user_structure = {};
        this.documentDetail = {
          documentId: null,
          status: null,
          statusId: null,
          isLocked: true,
          referenceNumber: "",
          subject: "",
          createdOn: "",
          dueDate: "",
          balanceDays: "",
          createdBy: "",
          priority: "",
          priorityId: "",
        };
      }
    },
  },
  created() {
    this.getDocumentDetails();
  },
  methods: {
    closeSignMethodSelectAndOpenSignWithPin() {
      this.selectSignMethodFormDialog = false;
      this.signFormDialog = true;
    },
    closeSelectSignMethodFormDialog() {
      this.selectSignMethodFormDialog = false;
    },
    signDocument() {
      this.propertyBag.documentId = this.documentId;
      this.propertyBag.delegationId = 0;
      this.propertyBag.isUserDefaultSignatureAvailable =
        this.documentDetail.defaultSignatureAvailable;
      this.dispatchFormDialog = true;
    },
    reviewDocument() {
      this.propertyBag.documentId = this.documentId;
      this.propertyBag.delegationId = 0;

      const formData = {
        DocumentIds: JSON.stringify(this.documentId),
        SignatureBytes: "",
        SignType: 5,
      };
      axios
        .post(constants.baseApiUrl + "Document/SignDocument", formData)
        .then((res) => {
          var response = res.data;
          if (response && response.data != null && res.data.success) {
            response.data.forEach((msg) => {
              if (msg === "signCompleted") {
                // Correct way to check for "signCompleted"
                window.showAlert(this.$t("res_Msgs_SignedSuccess"), "success");
                this.$emit("refreshAfterClosingSignMethodSelect");
                this.refresh();
              } else if (msg.startsWith("cannotSign:")) {
                // Correct way to check for "cannotSign"
                let errorCode = msg.replace("cannotSign:", "");
                window.showAlert(
                  this.$t("res_Msg_PermissionToSignDocument") +
                    ": " +
                    errorCode,
                  "warning"
                );
              } else {
                window.showAlert(msg, "warning", 5000);
              }
            });
          } else window.showAlert("res_Msgs_ErrorOccured", "error");
        })
        .catch((error) => {
          window.showAlert("res_Msgs_ErrorOccured", "error");
        })
        .finally(() => {
          this.isLoading = false;
          window.hideLoading();
        });
    },
    closeDocumentDetailsDialog() {
      this.$emit("closeDocumentDetails");
    },
    refresh() {
      this.getDocumentDetails();
      this.$emit("refreshDocumentList");
    },
    printWithAttachments(showStamps) {
      utils.PrintFile(
        constants.baseApiUrl +
          "Document/DownloadWithAttachments?documentId=" +
          this.documentId +
          "&showStamps=" +
          showStamps,
        "print.pdf"
      );
    },
    downloadWithAttachments() {
      utils.DownloadFileWithoutName(
        constants.baseApiUrl +
          "Attachment/Download?attachmentId=" +
          this.documentDetail.attachmentId
      );
    },
    getDocumentDetails() {
      window.showLoading();
      if (this.documentId > 0) {
        axios
          .get(
            constants.baseApiUrl +
              "Document/GetDocumentInfo?documentId=" +
              this.documentId
          )
          .then((response) => {
            if (response.data.success) {
              this.documentDetail = response.data.data;
              this.documentDetail.documentId = this.documentId;
              window.documentView.document = this.documentDetail;
              this.collapseReadOnlyDetails = false;
              if (this.documentDetail.attachmentId != null)
                this.setViewerUrl(this.documentDetail.attachmentId);
            }
          })
          .catch((error) => console.log(error))
          .finally(() => window.hideLoading());
      }
    },
    setViewerUrl(attachmentId, forceShowAttachmentVersions = false) {
      this.attachmentId = attachmentId;
      if (attachmentId != 0) {
        this.empty_viewer = false;

        var viewerMode = "";
        if (this.viewMode == "viewMode" || this.viewMode == "readonly")
          viewerMode = "&pageMode=view";

        var viewerInstanceId = window.setViewerData(
          attachmentId,
          this.documentId,
          null,
          null
        );
        var ShowEditInWord = !this.documentDetail.isLocked
          ? "&ShowEditInWord=true"
          : "&ShowEditInWord=false";
        this.viewerFrameSrc =
          "/resources/viewer/viewer.html?lang=" +
          this.$i18n.locale +
          "" +
          viewerMode +
          "&r=" +
          new Date().getTime() +
          "&forceShowAttachmentVersions=" +
          forceShowAttachmentVersions +
          "&forceHideAttachments=false" +
          ShowEditInWord +
          "&viewerInstanceId=" +
          viewerInstanceId;
      } else {
        this.empty_viewer = true;
        this.viewerFrameSrc = "";
      }
    },
    refreshViewer() {
      if (this.viewerFrameSrc != "") {
        this.empty_viewer = false;
        this.viewerFrameSrc = this.viewerFrameSrc + "&refresh=" + Math.random();
        this.loading = false;
      }
    },
    canEditAttachments() {
      if (this.documentDetail.isSingedByUser) {
        return false;
      }
      return true;
    },
    canAddEditAttachments(isAdd) {
      if (!isAdd) {
        if (this.documentDetail.isSingedByUser) return false;
      }

      if (this.viewMode == "edit") return true;

      return false;
    },

    textColor(color) {
      const hex = color.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
      return luminance > 0.5 ? "#000000" : "#ffffff";
    },
    handleCloseDispatchDialog() {
      this.dispatchFormDialog = false;
      this.$emit("closeDocumentDetails");
    },
  },
};
</script>
<style scoped>
.ref_header_name {
  font-size: 1.5rem;
  line-height: 0.875rem;
  flex: 1;
  font-weight: 500;
  font-size: 21px;
  line-height: 30px;
  letter-spacing: -0.01em;
  color: var(--content-color2);
}
</style>
